<script setup>

    import { computed, onMounted, onUnmounted, watch } from 'vue'

    const props = defineProps({
        show: {
            type: Boolean,
            default: false,
        },
        paddingEnable: {
            type: Boolean,
            default: true,
        },
        maxWidth: {
            type: String,
            default: '2xl',
        },
        closeable: {
            type: Boolean,
            default: true,
        },
        verticalOffset: {
            type: Number,
        },
    })

    const emit = defineEmits(['close'])

    watch(
        () => props.show,
        () => {
            document.body.style.overflow = null
        }
    )

    const close = () => {
        if (props.closeable) {
            emit('close')
        }
    }

    const closeOnEscape = (event) => {
        if (event.key === 'Escape' && props.show) {
            close()
        }
    }

    onMounted(() => {
        document.addEventListener('keydown', closeOnEscape)
    })

    onUnmounted(() => {
        document.removeEventListener('keydown', closeOnEscape)
        document.body.style.overflow = null
    })

    const maxWidthClass = computed(() => {
        return {
            sm: 'sm:max-w-sm',
            md: 'sm:max-w-md',
            lg: 'sm:max-w-lg',
            xl: 'sm:max-w-xl',
            '2xl': 'sm:max-w-2xl',
            '3xl': 'sm:max-w-3xl',
            '4xl': 'sm:max-w-4xl',
        }[props.maxWidth]
    })

</script>

<template>

    <div
        v-show="show"
        class="absolute inset-0 z-overlay"
    >
        <div class="absolute inset-0 bg-lifeworx-blue-700/60 backdrop-blur-sm" />

        <div class="relative z-modal flex min-h-full items-start justify-center px-4 pt-4 text-center sm:items-center sm:pt-0">
            <div
                class="relative mx-auto transform overflow-hidden bg-white text-left shadow-xl transition-all md:rounded-b-lg sm:w-full"
                :class="[{
                    'px-4 pb-4 pt-5 sm:p-6': paddingEnable,
                }, maxWidthClass]"
                :style="props.verticalOffset ? { transform: `translateY(${props.verticalOffset}px)` } : null"
            >
                <button
                    type="button"
                    class="absolute right-4 top-4 rounded-full p-1 text-stone-400 transition hover:bg-stone-100 hover:text-stone-600"
                    aria-label="Close signature request dialog"
                    @click="close"
                >
                    <span class="text-2xl leading-none">&times;</span>
                </button>

                <slot />
            </div>
        </div>
    </div>

</template>
